module.exports = __webpack_public_path__ + "img/pic04.c5b07b6d.png";